import * as React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Loadable, { DefaultComponent } from '@loadable/component';

import styles from './index.module.scss';

import Provider from './Provider';
import IntlWrapper from '@locales/IntlWrapper';
import PageLoading from '@components/PageLoading';

const AppWrapper = ({ children }: { children?: React.ReactNode }) => (
    <div className={styles.appWrapper}>{children}</div>
);

export function loadComponent<T>(loader: (props: T) => Promise<DefaultComponent<T>>) {
    return Loadable(loader, { fallback: <PageLoading /> });
}

const InvalidPage = loadComponent(() => import(/* webpackChunkName: "invalid-page" */ '@views/InvalidPage'));
const HomePage = loadComponent(() => import(/* webpackChunkName: "home-page" */ '@views/HomePage'));
const VerificationPassPage = loadComponent(
    () => import(/* webpackChunkName: "verification-pass-page" */ '@views/VerificationPassPage')
);
const ResultPage = loadComponent(() => import(/* webpackChunkName: "result-page" */ '@views/ResultPage'));
const VerificationNoPassPage = loadComponent(
    () => import(/* webpackChunkName: "verification-no-pass-page" */ '@views/VerificationNoPassPage')
);
const CreatePage = loadComponent(() => import(/* webpackChunkName: "vcreate-page" */ '@views/CreatePage'));
const CreateTempPage = loadComponent(() => import(/* webpackChunkName: "create-temp-page" */ '@views/CreateTempPage'));
const CreateNormalOrReadPage = loadComponent(
    () => import(/* webpackChunkName: "vcreate-new-create-page" */ '@views/createNormalOrReadPage')
);
const VideoPage = loadComponent(() => import(/* webpackChunkName: "video-page" */ '@views/VideoPage'));
const ElectronPage = loadComponent(() => import(/* webpackChunkName: "electron-page" */ '@views/ElectronPage'));

function App() {
    return (
        <Provider>
            <IntlWrapper>
                <AppWrapper>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/invalid" element={<InvalidPage />} />
                            <Route path="/pass/:type" element={<VerificationPassPage />} />
                            <Route path="/result/:type" element={<ResultPage />} />
                            <Route path="/no-pass/:type" element={<VerificationNoPassPage />} />
                            <Route path="/create/:type" element={<CreatePage />} />
                            <Route path="/create/temp" element={<CreateTempPage />} />
                            <Route path="/video" element={<VideoPage />} />
                            <Route path="/verifyH5/*" element={<HomePage />} />
                            {/*<Route path="/*" element={<CreatePage />} />*/}
                            <Route path="/create/std" element={<CreateNormalOrReadPage />} />
                            <Route path="/electron/*" element={<ElectronPage />} />
                        </Routes>
                    </BrowserRouter>
                </AppWrapper>
            </IntlWrapper>
        </Provider>
    );
}

export default App;
